import { type Dispatch, type SetStateAction } from 'react';

import { type INavLinks, type TSectionAnchor } from 'shared/settings/routes';
import { setHash } from 'shared/utils/setHash';

export function updateActiveSection(
  sections: INavLinks[],
  onActiveSection: Dispatch<SetStateAction<TSectionAnchor>>,
): void {
  if (sections.length < 1) {
    return;
  }

  const scrollY = window.pageYOffset;
  const lastSection = sections.at(-1);

  if (lastSection?.value && scrollY + window.innerHeight >= document.documentElement.scrollHeight) {
    onActiveSection(lastSection.value as TSectionAnchor);
    setHash(lastSection.value);

    return;
  }

  sections.forEach(section => {
    const sectionTop = section.offsetTop - 100;

    if (section.value && scrollY > sectionTop && scrollY <= sectionTop + section.offsetHeight) {
      onActiveSection(section.value as TSectionAnchor);
      setHash(section.value);
    }
  });
}
